import PropTypes from "prop-types"
import React, { Component } from "react"

//Simple bar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"



class SidebarContent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      user:JSON.parse(sessionStorage.getItem("authAshia"))

    }
    this.refDiv = React.createRef()
  }

  componentDidMount() {
    this.initMenu()
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, ss) {
    if (this.props.type !== prevProps.type) {
      this.initMenu()
    }
  }

  initMenu() {
    new MetisMenu("#side-menu")

    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    for (let i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem)
    }
  }

  // componentDidUpdate() {}

  scrollElement = item => {
    // setTimeout(() => {
    //   if (this.refDiv.current !== null) {
    //     if (item) {
    //       const currentPosition = item.offsetTop
    //       if (currentPosition > window.innerHeight) {
    //         if (this.refDiv.current)
    //           this.refDiv.current.getScrollElement().scrollTop =
    //             currentPosition - 300
    //       }
    //     }
    //   }
    // }, 300)
  }

  activateParentDropdown = item => {
    item.classList.add("active")
    const parent = item.parentElement

    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      this.scrollElement(item)
      return false
    }
    this.scrollElement(item)
    return false
  }

  render() {
    return (
      <React.Fragment>
        <SimpleBar style={{ maxHeight: "100%" }} ref={this.refDiv}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu">
              
              {/* <li className="menu-title">{this.props.t("Menu")}</li> */}
              
              <li id="acceuil-link">
                <Link to="/accueil" className="waves-effect">
                  <i className="bx bx-home-circle" />
                  {/* <span className="badge rounded-pill bg-info float-end">
                    04
                  </span> */}
                  <span>{this.props.t("Accueil")}</span>
                </Link>
                {/* <Link to="/dashboard">{this.props.t("Default")}</Link> */}
                
              </li>

              {/* <li className="menu-title">{this.props.t("Apps")}</li> */}
              
              <li>
                <Link to="/liste-ressource" className=" waves-effect">
                  <i className="bx bxs-bookmark-alt-plus" />
                  <span>{this.props.t("Ressources")}</span>
                </Link>
              </li>

              <li>
                <Link to="/liste-expert" className=" waves-effect">
                  <i class='bx bxs-user-check' ></i>
                  <span>{this.props.t("Acteurs")}</span>
                </Link>
              </li>

              {/* <li>
                <Link to="/liste-evenement" className=" waves-effect">
                  <i className="bx bx-calendar-event" />
                  <span>{this.props.t("Evenement")}</span>
                </Link>
              </li> */}

              <li>
                <Link to="/liste-calendar" className=" waves-effect">
                  <i className="bx bx-calendar" />
                  <span>{this.props.t("Calendrier")}</span>
                </Link>
              </li>
              {
                
               this.state.user?
                  <>
                    <li>
                      <Link to="/reporting" className=" waves-effect">
                        <i className="bx bxs-bar-chart-alt-2" />
                        <span>{this.props.t("Reporting")}</span>
                      </Link>
                    </li>
                
                      <li>
                        <a href="http://pariis.cilss.int/espacedechange/index.php?ctrl=file" target="_blank"  className=" waves-effect">
                          <i className="bx bxs-chat" />
                          <span>{"Forum"}</span>
                        </a>
                      </li>
                  

                  <hr/>

                  <li>
                    <a href="http://192.99.37.218/guide" target="_blank"  className=" waves-effect">
                      <i className="bx bx-directions" />
                      {/* <i className="bx bx-book-open" /> */}
                      <span>{"Guide d'utilisation"}</span>
                    </a>
                  </li>
                  </>:null
              }

            </ul>
          </div>
        </SimpleBar>
      </React.Fragment>
    )
  }
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  type: PropTypes.string,
}

export default withRouter(withTranslation()(SidebarContent))
